module.exports = __webpack_public_path__ + "media/images/home/image1-ce45a698e4b9bdb0c5522917e8ba3b87.jpeg";